const userRolesQueryKeys = {
  all: ["roles"] as const,
  me: () => [...userRolesQueryKeys.all, "me"] as const,
};

export default userRolesQueryKeys;
